import { DomainToSelect } from '../../CrossSaleModal.types'

interface UseChangeByAccessorProps {
  setDomainsToSelect: (domains: DomainToSelect[]) => void
  domainsToSelect: DomainToSelect[]
  isALlSelectedObject: {
    allSelected: boolean
    allMonitored: boolean
    allWordPress: boolean
  }
}

export const useChangeByAccessor = ({
  domainsToSelect,
  setDomainsToSelect,
  isALlSelectedObject,
}: UseChangeByAccessorProps) => {
  const addDomainToSelect = (domain: DomainToSelect) => {
    setDomainsToSelect([...domainsToSelect, domain])
  }

  const changeDomainByAccessor = (domain: DomainToSelect, key: string): DomainToSelect => {
    // ctoggle key of the domain
    const selectedDomain = {
      ...domain,
      [key]: !domain[key],
    }
    // if wordpress is selected, bz monitor should be selected automatically
    if (key === 'wordpress' && !selectedDomain.wordpress) {
      selectedDomain.isBzMonitor = true
    }
    return selectedDomain
  }

  const findAndChangeDomain = (domainId: number, key: string) => {
    const newDomains = domainsToSelect.map((domain) => {
      if (domain.id === domainId) {
        return changeDomainByAccessor(domain, key)
      }
      return domain
    })
    setDomainsToSelect(newDomains)
  }

  const changeAllDomains = (key: string, isAllTrue) => {
    const newDomains = domainsToSelect.map((domain) => ({
      ...domain,
      // if all wordpress is selected, all bz monitor should be selected automatically
      isBzMonitor: key === 'wordpress' && isAllTrue ? true : domain.isBzMonitor,
      [key]: !isAllTrue,
    }))
    setDomainsToSelect(newDomains)
  }

  const onDomainSelect = (domainId: number) => () => {
    findAndChangeDomain(domainId, 'isSelected')
  }

  const onAllDomainsSelect = () => {
    changeAllDomains('isSelected', isALlSelectedObject.allSelected)
  }

  const onIsMonitoredChange = (domainId: number) => () => {
    findAndChangeDomain(domainId, 'isBzMonitor')
  }

  const onAllMonitoredChange = () => {
    changeAllDomains('isBzMonitor', isALlSelectedObject.allMonitored)
  }

  const onIsWordPressChange = (domainId: number) => () => {
    findAndChangeDomain(domainId, 'wordpress')
  }

  const onAllWordPressChange = () => {
    changeAllDomains('wordpress', isALlSelectedObject.allWordPress)
  }

  const changeAllByAccessor = (accessor: string) => () => {
    switch (accessor) {
      case 'isSelected':
        onAllDomainsSelect()
        break
      case 'wordpress':
        onAllWordPressChange()
        break
      case 'isBzMonitor':
        onAllMonitoredChange()
        break
    }
  }

  const allSelectedByAccessor = (accessor: string) => {
    switch (accessor) {
      case 'isSelected':
        return isALlSelectedObject.allSelected
      case 'wordpress':
        return isALlSelectedObject.allWordPress
      case 'isBzMonitor':
        return isALlSelectedObject.allMonitored
      default:
        return false
    }
  }

  return {
    allSelectedByAccessor,
    changeAllByAccessor,
    onIsWordPressChange,
    onIsMonitoredChange,
    onDomainSelect,
    onAllDomainsSelect,
    onAllMonitoredChange,
    onAllWordPressChange,
    changeDomainByAccessor,
    addDomainToSelect,
  }
}
